import Vue from 'vue'
import App from './App.vue'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/saga-blue/theme.css';   
import 'primevue/resources/primevue.min.css';   
import 'primeicons/primeicons.css';	 

import reactiveStorage from "vue-reactive-storage";

import VueSimpleContextMenu from 'vue-simple-context-menu'
Vue.component('vue-simple-context-menu', VueSimpleContextMenu)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.use(reactiveStorage, {
  "token": null,
});

Vue.use(PrimeVue);


new Vue({
  render: h => h(App),
}).$mount('#app')
